/**
 * Boot Screen Messages API Contract
 *
 * PUT /v1/schools/:id/boot-screen/messages
 * Updates per-school boot messages. Last-write-wins (no version handshake).
 */

import { z } from 'zod'
import {
  BOOT_SCREEN_MESSAGE_MAX_LENGTH,
  BOOT_SCREEN_MESSAGES_MAX,
  BootScreenConfigSchema
} from '../../schemas/entities/boot-screen'

const URL_REJECT_REGEX = /(https?|ftp):\/\//i

const PutBootScreenMessageInputSchema = z.object({
  id: z.string().min(1).optional(),
  text: z
    .string()
    .trim()
    .min(1, 'Message cannot be empty')
    .max(BOOT_SCREEN_MESSAGE_MAX_LENGTH, `Message must be ≤${BOOT_SCREEN_MESSAGE_MAX_LENGTH} characters`)
    .refine(value => !URL_REJECT_REGEX.test(value), {
      message: 'URLs are not allowed in boot messages'
    })
})

export type PutBootScreenMessageInput = z.infer<typeof PutBootScreenMessageInputSchema>

export const PutBootScreenMessagesRequestSchema = z.object({
  enabled: z.boolean().optional(),
  messages: z.array(PutBootScreenMessageInputSchema).max(BOOT_SCREEN_MESSAGES_MAX)
})

export type PutBootScreenMessagesRequest = z.infer<typeof PutBootScreenMessagesRequestSchema>

export const PutBootScreenMessagesResponseSchema = z.object({
  data: BootScreenConfigSchema,
  message: z.string()
})

export type PutBootScreenMessagesResponse = z.infer<typeof PutBootScreenMessagesResponseSchema>
